// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-timer {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.2rem 0.6rem;
  transition: color 0.3s, border-color 0.3s, background 0.3s;
}
.session-timer__icono {
  font-size: 0.85rem;
}
.session-timer__tiempo {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.05em;
}
.session-timer--urgente {
  color: #842029;
  background: #f8d7da;
  border-color: #f5c2c7;
}

@keyframes parpadeo {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/session-timer/session-timer.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,0DAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,kCAAA;EACA,sBAAA;AAAJ;AAGE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AADJ;;AAKA;EACE;IAAW,UAAA;EADX;EAEA;IAAY,YAAA;EACZ;AACF","sourcesContent":[".session-timer {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #495057;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n  padding: 0.2rem 0.6rem;\n  transition: color 0.3s, border-color 0.3s, background 0.3s;\n\n  &__icono {\n    font-size: 0.85rem;\n  }\n\n  &__tiempo {\n    font-variant-numeric: tabular-nums;\n    letter-spacing: 0.05em;\n  }\n\n  &--urgente {\n    color: #842029;\n    background: #f8d7da;\n    border-color: #f5c2c7;\n  }\n}\n\n@keyframes parpadeo {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0.4; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
